import axios from 'axios';
import { BASE_URL } from '@/plugins/url-env'

const $axios = axios.create({
    baseURL: BASE_URL,
    timeout: 100000,
    withCredentials: true,
});

export default $axios;